import React from "react";
import { motion } from "framer-motion";

/**
 * StaggerText Component
 * Animates text word by word or character by character.
 * 
 * Props:
 * - text: The text string to animate
 * - delay: Initial delay
 * - className: CSS classes for the text wrapper
 */
export const StaggerText = ({ text, delay = 0, className = "" }) => {
    const words = text.split(" ");

    const container = {
        hidden: { opacity: 0 },
        visible: (i = 1) => ({
            opacity: 1,
            transition: { staggerChildren: 0.12, delayChildren: 0.04 * i + delay },
        }),
    };

    const child = {
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                type: "spring",
                damping: 12,
                stiffness: 100,
            },
        },
        hidden: {
            opacity: 0,
            y: 20,
            transition: {
                type: "spring",
                damping: 12,
                stiffness: 100,
            },
        },
    };

    return (
        <motion.div
            style={{ overflow: "hidden", display: "flex", flexWrap: "wrap" }}
            variants={container}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className={className}
        >
            {words.map((word, index) => (
                <motion.span variants={child} key={index} style={{ marginRight: "0.25em" }}>
                    {word}
                </motion.span>
            ))}
        </motion.div>
    );
};
